module.exports = __webpack_public_path__ + "img/united-states.60b5c13f.png";